import { exists } from '../runtime.js';

/* tslint:disable */
function ApiRentalCarOfficeFromJSON(json) {
    return ApiRentalCarOfficeFromJSONTyped(json);
}
function ApiRentalCarOfficeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'addressAdditionalInfo': !exists(json, 'addressAdditionalInfo') ? undefined : json['addressAdditionalInfo'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'manualAddress': !exists(json, 'manualAddress') ? undefined : json['manualAddress'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'postalCode': !exists(json, 'postalCode') ? undefined : json['postalCode'],
        'street': !exists(json, 'street') ? undefined : json['street'],
        'arrivingTime': !exists(json, 'arrivingTime') ? undefined : (json['arrivingTime']),
        'inventory': !exists(json, 'inventory') ? undefined : json['inventory'],
        'supplierLocationCode': !exists(json, 'supplierLocationCode') ? undefined : json['supplierLocationCode'],
        'supplierCode': !exists(json, 'supplierCode') ? undefined : json['supplierCode'],
        'geographicUnitCode': !exists(json, 'geographicUnitCode') ? undefined : json['geographicUnitCode'],
        'geographicUnitTypeCode': !exists(json, 'geographicUnitTypeCode') ? undefined : json['geographicUnitTypeCode'],
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
    };
}
function ApiRentalCarOfficeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'addressAdditionalInfo': value.addressAdditionalInfo,
        'city': value.city,
        'country': value.country,
        'description': value.description,
        'manualAddress': value.manualAddress,
        'code': value.code,
        'postalCode': value.postalCode,
        'street': value.street,
        'arrivingTime': value.arrivingTime === undefined ? undefined : (value.arrivingTime),
        'inventory': value.inventory,
        'supplierLocationCode': value.supplierLocationCode,
        'supplierCode': value.supplierCode,
        'geographicUnitCode': value.geographicUnitCode,
        'geographicUnitTypeCode': value.geographicUnitTypeCode,
        'latitude': value.latitude,
        'longitude': value.longitude,
    };
}

export { ApiRentalCarOfficeFromJSON, ApiRentalCarOfficeFromJSONTyped, ApiRentalCarOfficeToJSON };
//# sourceMappingURL=ApiRentalCarOffice.js.map
